export default __webpack_public_path__ + "static/media/fauna-runas.a389f8af.png";